import { useState } from 'react';
import { api } from '../api.js';

export default function NewStudentModal({ onClose }) {
  const [kuerzel, setKuerzel]   = useState('');
  const [stufe, setStufe]       = useState('1');
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      await api.createStudent({ kuerzel: kuerzel.trim(), stufe_ziel: Number(stufe) });
      onClose();
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="card max-w-sm w-full space-y-4">
        <h2 className="font-bold text-gray-900">Neuen Schüler anlegen</h2>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="label">Kürzel / Pseudonym</label>
            <input className="input" value={kuerzel} onChange={(e) => setKuerzel(e.target.value)}
              placeholder="z.B. MA oder Müller" required />
          </div>
          <div>
            <label className="label">Zielstufe</label>
            <select className="input" value={stufe} onChange={(e) => setStufe(e.target.value)}>
              <option value="1">Stufe 1</option>
              <option value="2">Stufe 2</option>
            </select>
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <div className="flex gap-2 justify-end pt-1">
            <button type="button" onClick={onClose} className="btn-secondary">Abbrechen</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Speichern…' : 'Anlegen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
